import * as React from "react";
function SvgLike(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M17.36 3.22c1.62 0 3 2.59 3 4.71a5.86 5.86 0 01-.07.88L19.65 13h8.13a2 2 0 011.41.59 1.78 1.78 0 01.54 1.27 1.84 1.84 0 01-.73 1.5l-.76.57.83.47a1.85 1.85 0 01-.36 3.38l-.85.26.53.71a1.84 1.84 0 01-1.17 2.93l-.85.14.4.76a1.82 1.82 0 01.21.85 1.85 1.85 0 01-1.73 1.84H14.59a4 4 0 01-2.27-.83 2.49 2.49 0 00-.59-.39L11.5 27v-9.9l1.11-1 3.75-7a3.09 3.09 0 00.44-1.84l-.3-3.9a1.72 1.72 0 01.85-.23m0-2a3.73 3.73 0 00-1.84.49l-1.1.63.1 1.26.3 3.9a1.09 1.09 0 010 .34 1.1 1.1 0 01-.13.31L11 14.87l-.83.71-.7.6v12.06l1.17.53.23.1.13.13a5.9 5.9 0 003.53 1.31h10.84A3.85 3.85 0 0029 26.43v-.31a3.86 3.86 0 001.69-4.18 3.85 3.85 0 00.6-5.21 3.83 3.83 0 00.47-1.82 3.76 3.76 0 00-1.12-2.69A4 4 0 0027.78 11H22l.3-1.92a7.87 7.87 0 00.09-1.18c0-3.17-2.14-6.71-5-6.71z" />
      <path d="M9.46 14.4v14H2v-14h7.46m0-2H2a2 2 0 00-2 2v14a2 2 0 002 2h7.46a2 2 0 002-2v-14a2 2 0 00-2-2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLike);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
